import { PrecomputedAmenityData } from "~/types";
import * as APITypes from "~/API";

export const getFilteredAmenityList = (
  amenityList: PrecomputedAmenityData[],
  isAdminOrSuperAdmin: boolean
): PrecomputedAmenityData[] => {
  let filteredList = amenityList;

  // Filter by access rights (only if not admin/superadmin)
  if (!isAdminOrSuperAdmin) {
    filteredList = filteredList.filter((amenityData) => {
      return (
        amenityData.formattedAmenityDetails.accessRights?.readAccessStatus ===
          APITypes.ResourceAccessRightStatus.Granted ||
        amenityData.formattedAmenityDetails.accessRights?.writeAccessStatus ===
          APITypes.ResourceAccessRightStatus.Granted
      );
    });
  }

  return filteredList;
};
